document.addEventListener('DOMContentLoaded', function() {
  var loadSvgDetails = [
    {
      'selector': ['#shopify-section-template--24009034531143__173298802648394f84 #shopify-block-kehio_editor_app_block_faq_xiFMrp'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0863/7635/0023/files/F_Gradient_White.svg?v=1733046094',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '0',
        'width': '40%',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_3',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '40%'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '40%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '40%'
          },
          '(min-width: 1440px)': {
    		'width': '40%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21471196152107__1686159157bc3d096d','#shopify-section-template--22578758320427__16900405694738ec8e','#shopify-section-template--22578784600363__16900357188b2b8cdb'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0741/2829/4187/files/K_Gradient_Orange.svg?v=1699536451',
      'css': {
        'position': 'absolute',
        'right': '0',
        'top': '0',
        'z-index': '0',
        'width': '100%',
        'opacity': '0.5',
        'class': 'svg_bg_4',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
  ];

  var resizeTimeout;//

  var resizeTimeout;

  for (var i = 0; i < loadSvgDetails.length; i++) {
    
    var selectors = loadSvgDetails[i].selector;
    var svgType = loadSvgDetails[i].svg;
    var cssProperties = loadSvgDetails[i].css;
    var mediaQueries = cssProperties.mediaQueries;
    var container = document.createElement('div');
    if(typeof loadSvgDetails[i].svg_url !== "undefined" && loadSvgDetails[i].svg_url != ''){
      var innerHtmlToAdd = '<img alt src="'+loadSvgDetails[i].svg_url+'" >';
    }else{
      var innerHtmlToAdd = svgData[svgType]
    }
    for (var s = 0; s < selectors.length; s++) {
      var selector = selectors[s];
      var element = document.querySelector(selector);
      if (element) {
        
        container.innerHTML = innerHtmlToAdd;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('dfredfd_container');
        container.classList.add(cssProperties.class);
        container.classList.add(cssProperties.class+'_'+s);
        container.classList.add('svg_bg_wrap');
        container.classList.add('fade_up_animate');
        //container.setAttribute('data-aos','fade-up');
        //container.setAttribute('data-aos-once','false');
       // if (window.scrollY === 0) {
         // container.setAttribute('data-aos-offset', '100');
       //   }
  
        applyCSSProperties(container, cssProperties);
  
        for (var mqQuery in mediaQueries) {
          var mqCSSProperties = mediaQueries[mqQuery];
  
          var mediaQueryList = window.matchMedia(mqQuery);
          mediaQueryList.addListener(createMediaQueryListener(container, mqCSSProperties));
  
          if (mediaQueryList.matches) {
            applyCSSProperties(container, mqCSSProperties);
          }
        }
        handleScroll();
        //Initialize AOS with desired options
        // AOS.init({
        //   duration: 1000,
        //   delay: 200,
        //   easing: 'ease-in-out',
        //  // data-aos-once
        //   // Add more options as needed
        // });
      } else {
        //console.log('Element with selector:', selector, ' not found.');
      }
    }
  }

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      for (var i = 0; i < loadSvgDetails.length; i++) {
        var selectors = loadSvgDetails[i].selector;
        
        var mediaQueries = loadSvgDetails[i].css.mediaQueries;
        for (var s = 0; s < selectors.length; s++) {
          var selector = selectors[s];
          
          var element = document.querySelector(selector);
  
          if (element) {
          //var container = element.querySelector('> .' + loadSvgDetails[i].css.class);
         // var childElements = Array.from(element.children);
          var container = document.querySelector(selector +' > .'+loadSvgDetails[i].css.class);

          for (var mqQuery in mediaQueries) {
            var mqCSSProperties = mediaQueries[mqQuery];
            var mediaQueryList = window.matchMedia(mqQuery);

            if (mediaQueryList.matches) {
              applyCSSProperties(container, mqCSSProperties);
            }
          }
        }
        }
      }
    }, 200); // Adjust the timeout duration as needed
  });
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        
        // Check if the top of the element has started entering the viewport from the bottom
        return rect.top >= 0 && rect.top < windowHeight;
    }
    
    function handleScroll() {
        const fadeUpElements = document.querySelectorAll('.fade_up_animate:not(.animated)');  // Select elements that are not yet visible
        //console.log(fadeUpElements.length)
        fadeUpElements.forEach(element => {
            if (isInViewport(element)) {
                element.classList.add('animated');
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);

  function createMediaQueryListener(element, properties) {
    return function(mql) {
      if (mql.matches) {
        applyCSSProperties(element, properties);
      }
    };
  }

  function applyCSSProperties(element, properties) {
    for (var property in properties) {
      if (property === 'class') {
        element.classList.add(properties[property]);
      } else {
        element.style[property] = properties[property];
      }
    }
  }
  var buttons = document.querySelectorAll('a[href="#discuteravecunexpert"]');

    // Iterate over the selected elements and bind the click event handler
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Code to execute when the button is clicked
        event.preventDefault();
        toggleDemoRequestForm();
        // Additional code...
      });
    });
    var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.14 94.88"><defs><style>.cls-1{fill:#772647;}</style></defs><g id="Calque_4"><path class="cls-1" d="M51.98,12.21l3.19-12.21,3.35.88-2.41,9.23,5.66,1.48-.78,2.98-9.01-2.35Z"/><path class="cls-1" d="M72.8,12.76l-1.48,2.39-4.04-2.51-.95,1.53,5.2,3.23-1.62,2.62-8.14-5.05,6.66-10.72,8.14,5.05-1.62,2.62-5.2-3.23-.97,1.57,4.04,2.51Z"/><path class="cls-1" d="M77.43,18.85c-1.63,1.34-1.71,3.31-.23,5.09.19.23.4.46.62.67l1.25-1.03-1.42-1.71,2.17-1.79,3.53,4.28-5.19,4.28c-1.2-.53-2.27-1.43-3.44-2.85-2.78-3.37-2.6-7.09.47-9.63s6.76-2.01,9.55,1.35c1.17,1.42,1.85,2.63,2.15,3.92l-2.89,2.38-.1-.12c.1-1.46-.42-2.86-1.44-4.11-1.48-1.79-3.42-2.08-5.04-.74Z"/><path class="cls-1" d="M85.27,30.8c-1.99.71-2.73,2.53-1.95,4.71.1.29.22.57.36.84l1.52-.54-.75-2.09,2.65-.95,1.87,5.23-6.34,2.26c-.95-.91-1.64-2.12-2.26-3.85-1.47-4.12-.03-7.56,3.72-8.9,3.76-1.34,7.05.41,8.52,4.53.62,1.74.85,3.11.69,4.42l-3.53,1.26-.05-.14c.59-1.34.58-2.83.04-4.35-.78-2.18-2.51-3.12-4.49-2.41Z"/><path class="cls-1" d="M94.5,41.11l.31,3.44-12.56,1.13-.31-3.44,12.56-1.13Z"/><path class="cls-1" d="M81.42,54.91l8.92-2.75v-.04s-8.19-1.41-8.19-1.41l.57-3.29,12.43,2.14-.77,4.49-7.71,2.37v.04s7.09,1.22,7.09,1.22l-.57,3.3-12.43-2.14.68-3.93Z"/><path class="cls-1" d="M84.21,65.77c-1.82-1.07-3.69-.47-4.86,1.53-.15.26-.29.53-.41.82l1.39.82,1.12-1.92,2.43,1.42-2.81,4.79-5.8-3.4c.09-1.31.57-2.62,1.5-4.21,2.21-3.77,5.77-4.88,9.21-2.86,3.44,2.02,4.21,5.66,2,9.43-.93,1.59-1.84,2.64-2.94,3.36l-3.23-1.89.08-.13c1.41-.41,2.54-1.37,3.36-2.76,1.17-2,.78-3.92-1.04-4.99Z"/><path class="cls-1" d="M73.39,86.96c-2.69,1.83-4.9,1.55-6.51-.81-1.6-2.36-1.06-4.52,1.63-6.35l1.82-1.24-2.23-3.27,2.86-1.95,7.1,10.43-4.68,3.19ZM70.39,82.24c-.93.63-1.1,1.21-.61,1.93.49.72,1.1.77,2.02.14l1.68-1.14-1.41-2.07-1.68,1.14Z"/><path class="cls-1" d="M61.38,79.47l3.62,12.09-3.31.99-2.73-9.14-5.61,1.68-.88-2.95,8.92-2.67Z"/><path class="cls-1" d="M40.81,87.44c.08-3.76,1.96-5.56,5.71-5.48,3.7.08,5.47,1.96,5.39,5.72l-.16,7.2-3.46-.08.15-6.95c.04-1.86-.64-2.79-2.09-2.82s-2.17.87-2.21,2.73l-.15,6.95-3.34-.07.16-7.2Z"/><path class="cls-1" d="M28.65,77.13l-3.59,7.78.03.02,6.29-6.53,2.66,1.22-.84,8.69.03.02,3.45-7.49,3.04,1.4-5.28,11.46-4.68-2.15.84-8.04-.03-.02-5.57,5.87-4.78-2.2,5.28-11.46,3.14,1.45Z"/><path class="cls-1" d="M16.17,83.28l-2.54-2.35,8.57-9.26,2.54,2.35-8.57,9.26Z"/><path class="cls-1" d="M9.05,63.34c0-1.3.58-2.31,1.73-2.9,2.06-1.06,4.13,0,5.6,2.86.81,1.57,1.18,3.2.97,4.29l-3.02,1.56-.07-.14c.5-1.2.31-2.92-.42-4.34-.55-1.06-1.26-1.45-2.04-1.05-.62.32-.6.91.1,2.28l.73,1.42-2.36,1.22-.65-1.25c-.71-1.37-1.17-1.73-1.79-1.41-.78.4-.9,1.17-.37,2.18.63,1.22,1.81,2.23,3.03,2.56l.07.14-3.02,1.56c-1.03-.58-2.06-1.8-2.8-3.24-1.36-2.64-.97-4.82,1.09-5.89,1.08-.56,2.19-.49,3.18.16l.03-.02Z"/><path class="cls-1" d="M.1,53.95c-.58-4.29,1.34-6.97,5.35-7.51s6.57,1.53,7.15,5.82l.69,5.14-12.5,1.68-.69-5.14ZM9.58,52.88c-.31-2.3-1.51-3.27-3.66-2.98s-3.05,1.54-2.74,3.84l.2,1.51,6.4-.86-.2-1.51Z"/><path class="cls-1" d="M13.21,33.31c1,.35,1.5,1.37,1.15,2.37-.35,1-1.37,1.5-2.37,1.15-1-.35-1.5-1.37-1.15-2.37.35-1,1.37-1.5,2.37-1.15Z"/><path class="cls-1" d="M19.21,26.11l-9.25-1.16-.02.03,6.9,4.65-1.87,2.77-10.46-7.05,2.55-3.78,8.01,1,.02-.03-5.97-4.02,1.87-2.77,10.46,7.05-2.23,3.31Z"/><path class="cls-1" d="M20.64,10.86c1.07,1.28.92,3.02-.36,4.09-1.28,1.07-3.02.92-4.09-.36-1.07-1.28-.92-3.02.36-4.1,1.28-1.07,3.02-.92,4.1.36ZM17.61,13.4c.44.52,1.05.6,1.53.2.5-.42.54-1.04.1-1.57-.44-.52-1.07-.59-1.56-.18-.48.4-.51,1.02-.07,1.54Z"/><path class="cls-1" d="M32.61,15.35l-3.8-8.1-2.41,3.46-1.42-3.03,2.77-3.99,2.42-1.14,5.36,11.42-2.92,1.37Z"/><path class="cls-1" d="M41.62,10.86c.22,1.04-.4,1.99-1.45,2.2s-1.99-.4-2.2-1.45.4-1.99,1.45-2.2,1.99.4,2.2,1.45Z"/></g></svg>';
    var imageSelector = [
      {'selector':'#faq_body_6405_info_7_1_1 > div','type':'left_svg'},
      {'selector':'#faq_body_6408_info_10_1_1 > div','type':'right_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }

});
